import React, { useRef } from "react";
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";

const myLibraries = ['places']
const gMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API

const GooglePlaceSearch = (props) => {
    const inputRef = useRef();

    const handlePlaceChanged = () => {
        const [ place ] = inputRef.current.getPlaces()

        console.log(place)
        if(place) {
            console.log(place.formatted_address)
            console.log(place.geometry.location.lat())
            console.log(place.geometry.location.lng())

            const geoztgData = {place: place.formatted_address, latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng()}
            props.onDataChange(geoztgData)            
        } else {
            const geoztgData = {place: '', latitude: '', longitude: ''}
            props.onDataChange(geoztgData)
        }
    }

    return (
        <LoadScript googleMapsApiKey={gMapApiKey} libraries={myLibraries}>
                <StandaloneSearchBox
                    onLoad={ref => inputRef.current = ref}
                    onPlacesChanged={handlePlaceChanged}
                >
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Location"
                    />
                </StandaloneSearchBox>
        </LoadScript>
    );
};

export default GooglePlaceSearch;